// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-items-module--wrapper--410fb","item":"nav-items-module--item--7ec5c"};